import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import SidebarBoarding from "../../components/SidebarDashboard";
import CustomNavbar from "../../components/CustomNavbar";
import {
  Container,
  Button,
  Card,
  Row,
  Col,
  Modal,
  Badge,
  Tab,
  Tabs,
} from "react-bootstrap";
import {
  FaBook,
  FaGraduationCap,
  FaChalkboardTeacher,
  FaUserGraduate,
  FaCalendarAlt,
  FaUserFriends,
  FaPenAlt,
  FaUniversity,
  FaClipboardList,
  FaLightbulb,
  FaCheck,
  FaUserTie,
} from "react-icons/fa";
import {
  getCoursesEmployees,
  newEnrollmentEmployee,
} from "../../redux/capacitacionDesarrollo/Enrollment/actions";
import CourseApprovals from "../../components/capacitacionDesarrollo/CourseApprovals";

const iconosCursos = [
  FaBook,
  FaChalkboardTeacher,
  FaGraduationCap,
  FaPenAlt,
  FaUserGraduate,
  FaUniversity,
  FaLightbulb,
  FaClipboardList,
  FaUserFriends,
];

const coloresIconos = [
  "#3498db",
  "#e74c3c",
  "#2ecc71",
  "#f39c12",
  "#9b59b6",
  "#1abc9c",
  "#d35400",
  "#34495e",
];

const EnrollmentRequest = () => {
  // Estados
  const dispatch = useDispatch();
  const [mostrarSidebar, setMostrarSidebar] = useState(false);
  const [cursoSeleccionado, setCursoSeleccionado] = useState(null);
  const [mostrarModal, setMostrarModal] = useState(false);
  const [estadoInscripcion, setEstadoInscripcion] = useState({});
  const [activeTab, setActiveTab] = useState("courses");

  //Store
  const {
    loaderCoursesEmployees,
    coursesEmployees,
    coursesEmployeesFail,
    loaderEnrollment,
    enrollmentSuccess,
    enrollmentFail,
  } = useSelector((store) => store.CoursesEnrollment);
  const { username } = useSelector((store) => store.auth);
  const userRoles = useSelector((store) => store.auth.userRoles);

  const isJefe = userRoles?.includes("jefe");

  useEffect(() => {
    if (username) {
      dispatch(getCoursesEmployees({ codigo_empleado: username }));
    }
  }, [dispatch, username]);

  useEffect(() => {
    if (enrollmentSuccess) {
      dispatch(getCoursesEmployees({ codigo_empleado: username }));
      setEstadoInscripcion((prev) => ({
        ...prev,
        [cursoSeleccionado?.id]: "¡Inscripción exitosa!",
      }));

      setTimeout(() => {
        setMostrarModal(false);
        setCursoSeleccionado(null);
      }, 2000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enrollmentSuccess, dispatch, username]);

  const alternarSidebar = () => setMostrarSidebar(!mostrarSidebar);

  const manejarClickCurso = (curso) => {
    setCursoSeleccionado(curso);
    setMostrarModal(true);
    setEstadoInscripcion((prev) => ({
      ...prev,
      [curso.id]: null,
    }));
  };

  const manejarInscripcion = (cursoId) => {
    if (username && cursoId) {
      dispatch(
        newEnrollmentEmployee({
          empleado_codigo: username,
          curso_id: cursoId,
        })
      );
    }
  };

  const renderCoursesTab = () => (
    <>
      <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
        <div>
          <h6 className="font-weight-bold text-uppercase">
            Registro de Participación en Cursos
          </h6>
          {!loaderCoursesEmployees && !coursesEmployeesFail && (
            <p className="text-muted mb-0">
              {coursesEmployees?.count} cursos disponibles
            </p>
          )}
        </div>
      </div>

      {loaderCoursesEmployees ? (
        <div className="text-center my-5">
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Cargando...</span>
          </div>
        </div>
      ) : coursesEmployeesFail ? (
        <div className="alert alert-danger my-4">
          Error al cargar los cursos. Por favor intente nuevamente.
        </div>
      ) : (
        <Row className="mt-4 px-3">
          {coursesEmployees?.results?.map((curso, index) => {
            const IconoCurso = iconosCursos[index % iconosCursos.length];
            const colorIcono = coloresIconos[index % coloresIconos.length];
            return (
              <Col key={curso.id} md={6} lg={4} xl={3} className="mb-4">
                <Card
                  className="h-100 shadow-sm border-0"
                  onClick={() => manejarClickCurso(curso)}
                  style={{ cursor: "pointer", borderRadius: "0.75rem" }}
                >
                  {curso.esta_matriculado && (
                    <Badge
                      pill
                      bg="success"
                      className="position-absolute"
                      style={{
                        top: "10px",
                        right: "10px",
                        fontSize: "0.75rem",
                        padding: "0.4em 0.6em",
                      }}
                    >
                      <FaCheck className="me-1" /> Matriculado
                    </Badge>
                  )}

                  <Card.Header className="bg-light text-center border-bottom-0">
                    <div
                      className="d-flex justify-content-center align-items-center mx-auto"
                      style={{
                        width: 60,
                        height: 60,
                        borderRadius: "50%",
                        backgroundColor: "#f0f2f5",
                      }}
                    >
                      <IconoCurso size={32} style={{ color: colorIcono }} />
                    </div>
                  </Card.Header>

                  <Card.Body className="text-center px-3">
                    <Card.Title className="fw-semibold text-dark">
                      {curso.nombre}
                    </Card.Title>
                    <Card.Subtitle
                      className="mb-2 text-muted"
                      style={{ fontSize: "0.85rem" }}
                    >
                      {curso.instructor}
                    </Card.Subtitle>
                    <Card.Text
                      className="text-muted"
                      style={{
                        fontSize: "0.9rem",
                        textAlign: "justify",
                        maxHeight: "4.5em",
                        overflow: "hidden",
                      }}
                    >
                      {curso.descripcion}
                    </Card.Text>
                  </Card.Body>

                  <Card.Footer className="bg-white border-top text-center">
                    <small className="text-muted">
                      Inicia: <strong>{curso.fecha_inicio_curso}</strong> •{" "}
                      {curso.duracion_horas} hrs
                    </small>
                  </Card.Footer>
                </Card>
              </Col>
            );
          })}
        </Row>
      )}
    </>
  );

  return (
    <>
      <SidebarBoarding show={mostrarSidebar} onShowSidebar={alternarSidebar} />
      <CustomNavbar type={"dashboard"} onShowSidebar={alternarSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          {isJefe ? (
            <Tabs
              activeKey={activeTab}
              onSelect={(k) => setActiveTab(k)}
              className="mb-3"
            >
              <Tab eventKey="courses" title="Panel de Cursos Publicados">
                {renderCoursesTab()}
              </Tab>
              <Tab eventKey="approvals" title="Aprobaciones de Cursos">
                <CourseApprovals />
              </Tab>
            </Tabs>
          ) : (
            <>
              <div className="my-1 d-flex flex-wrap justify-content-between align-items-center"></div>
              {renderCoursesTab()}
            </>
          )}
        </Container>
      </div>

      {/* Modal de Detalles del Curso */}
      <Modal
        show={mostrarModal}
        onHide={() => setMostrarModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>{cursoSeleccionado?.nombre}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="mx-2">
          {cursoSeleccionado && (
            <Row>
              <Col md={6}>
                <div className="text-center mb-4">
                  <div className="mb-3">
                    {(() => {
                      const index = coursesEmployees?.results?.findIndex(
                        (c) => c.id === cursoSeleccionado.id
                      );
                      const IconoModal =
                        iconosCursos[index % iconosCursos.length];
                      const colorIcono =
                        coloresIconos[index % coloresIconos.length];
                      return (
                        <IconoModal size={60} style={{ color: colorIcono }} />
                      );
                    })()}
                  </div>
                  <h5>Detalles del Curso</h5>
                </div>

                {cursoSeleccionado.esta_matriculado && (
                  <div className="alert alert-info mb-3">
                    <div className="d-flex align-items-center">
                      <FaCheck className="me-2" />
                      <span>&nbsp;Ya estás matriculado en este curso</span>
                    </div>
                    <div className="d-flex align-items-center mt-2">
                      <FaUserTie className="me-2" />
                      <span>
                        {cursoSeleccionado.aprobado_por_jefatura ? (
                          <span className="text-success">
                            &nbsp;Aprobado por jefatura
                          </span>
                        ) : (
                          <span className="text-warning">
                            &nbsp;Pendiente de aprobación por jefatura
                          </span>
                        )}
                      </span>
                    </div>
                  </div>
                )}

                <p>
                  <strong>
                    <FaChalkboardTeacher /> Instructor:
                  </strong>{" "}
                  {cursoSeleccionado.instructor}
                </p>
                <p>
                  <strong>
                    <FaBook /> Duración:
                  </strong>{" "}
                  {cursoSeleccionado.duracion_horas} horas
                </p>
                <p>
                  <strong>
                    <FaCalendarAlt /> Fecha de Inicio:
                  </strong>{" "}
                  {cursoSeleccionado.fecha_inicio_curso}
                </p>
                <p>
                  <strong>
                    <FaCalendarAlt /> Período de Inscripción:
                  </strong>{" "}
                  {cursoSeleccionado.fecha_inicio_registro} -{" "}
                  {cursoSeleccionado.fecha_fin_registro}
                </p>
              </Col>
              <Col md={6}>
                <h5>Descripción del Curso</h5>
                <p>{cursoSeleccionado.descripcion}</p>

                <div className="mt-4">
                  <h5>Objetivos</h5>
                  <p>{cursoSeleccionado.objetivos}</p>
                </div>

                <div className="mt-4">
                  <h5>Inscripción</h5>
                  {estadoInscripcion[cursoSeleccionado.id] ? (
                    <div className="alert alert-success">
                      {estadoInscripcion[cursoSeleccionado.id]}
                    </div>
                  ) : enrollmentFail ? (
                    <div className="alert alert-danger">
                      Error al inscribirse. Por favor intente nuevamente.
                    </div>
                  ) : (
                    <Button
                      variant="primary"
                      onClick={() => manejarInscripcion(cursoSeleccionado.id)}
                      disabled={
                        cursoSeleccionado.esta_matriculado || loaderEnrollment
                      }
                    >
                      {loaderEnrollment ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Procesando...
                        </>
                      ) : cursoSeleccionado.esta_matriculado ? (
                        "Ya estás inscrito"
                      ) : (
                        "Inscribirse Ahora"
                      )}
                    </Button>
                  )}
                </div>
              </Col>
            </Row>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default EnrollmentRequest;
